import React from 'react'
import { ComponentExt } from 'util/reactExt'
import moment from 'moment'
import { DatePicker } from 'antd'
import PieChart from 'containers/shared/PieChart'

const { MonthPicker } = DatePicker

interface ICompareWithAllPieProps {
  staffid?: string | number
}

class ICompareWithAllPie extends ComponentExt<ICompareWithAllPieProps> {
  state = {
    compareData: [],
    pkMoment: moment(),
    date: moment().format('YYYY-MM'),
  }

  componentDidMount() {
    this.fetchCompareWithAllAreaData(moment().format('YYYY-MM'))
  }

  async fetchCompareWithAllAreaData(date) {
    const data = await this.api.user.getCompareWithAllAreaData(
      date,
      this.props.staffid,
    )
    this.setState({
      compareData: data,
    })
  }

  handleSetDate = (m, date) => {
    this.setState({
      pkMoment: m,
      date,
    })

    if (date) {
      this.fetchCompareWithAllAreaData(date)
    }
  }

  render() {
    return (
      <div>
        <h4
          style={{
            fontSize: 14,
            color: '#333',
            marginTop: 32,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span>各大片区平均学习时长饼图</span>
          <MonthPicker
            placeholder={'请选择日期'}
            value={this.state.pkMoment}
            defaultValue={moment()}
            disabledDate={current =>
              (current && current > moment().endOf('day')) ||
              current < moment('2018-01-01')
            }
            onChange={(m, date) => this.handleSetDate(m, date)}
          />
        </h4>
        <PieChart
          fieldKey="avg_study"
          item="entity_name"
          data={this.state.compareData}
        />
      </div>
    )
  }
}

export default ICompareWithAllPie
